import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    fetchMasterList,
    addMasterRecord,
    deleteMasterRecord,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import {
    fetchReportsList
} from "../../../../redux/feature/manufacturing_app/commonReportListSlice";

import ConsumableModal from "./ConsumableFormModal";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import UploadExcel from "../../../../components/common/UploadExcel";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import { toastFunc } from "../../../../components/common/util";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { ErrorModal } from "../../../common/errorModal";
import { AlertModal } from "../../../common/AlertModal";
import { formatDateTime } from "../../../../common/Validations";
import ProdStatusFilterBox from "../../../../components/common/ProdStatusFilterBox";

const Consumable = () => {

    const [open, setOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState("");
    const [selectedItem, setSelectedItem] = useState([]);
    const [editConsumableSize, setEditConsumableSize] = useState();
    const [confirmModel, setConfirmModel] = useState(false);
    const [isAlert, setIsAlert] = useState(false);
    const [uploadModelOpen, setUploadModelOpen] = useState(false);
    const [displayFilter, setDisplayFilter] = useState(false);
    const [rowsData, setRowsData] = useState([]);

    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchMasterList(Constants.MASTER.CONSUMABLE)); // userSlice store
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const masterList = useSelector((state) => state?.masterList?.page);


    useEffect(() => {
        if (!displayFilter) {
            const data = masterList?.[Constants.MASTER.CONSUMABLE.name]?.data || [];
            setRowsData(data);
        }
    }, [displayFilter, masterList]);

    const handleUploadClose = () => {
        setUploadModelOpen(false);
    };

    const handleDelete = () => {
        let param = {};
        param.consumableList = selectedItem;
        param.method = Constants.MASTER.CONSUMABLE.DELETE;

        dispatch(deleteMasterRecord(param)).then((res) => {
            if (res?.payload?.status === 200) {
                toastFunc(
                    Constants.MASTER.TOAST.success,
                    t("msg_master_list.msg_consumable.delete_success_message"),
                    2000
                );
                dispatch(fetchMasterList(Constants.MASTER.CONSUMABLE));
                setSelectedItem([]);
                setConfirmModel(false);
                setDisplayFilter(false);
            } else {
                setIsError(true);
                toastFunc(
                    Constants.MASTER.TOAST.error,
                    t("msg_master_list.msg_reason.invalid_input"),
                    4000
                );
            }
        });
    };

    const handleSave = (data, edit) => {
        const param = { ...data };
        if (!edit) {
            param.method = Constants.MASTER.CONSUMABLE.ADD;
        } else {
            param.method = Constants.MASTER.CONSUMABLE.UPDATE;
        }
        param.edit = edit;
        dispatch(addMasterRecord(param)).then((res) => {
            if (res?.payload?.status === 200) {
                if (!edit) {
                    toastFunc(
                        Constants.MASTER.TOAST.success,
                        t("msg_master_list.msg_consumable.success_message"),
                        2000
                    );
                } else {
                    toastFunc(
                        Constants.MASTER.TOAST.success,
                        t("msg_master_list.msg_consumable.update_success_message"),
                        2000
                    );
                }
                dispatch(fetchMasterList(Constants.MASTER.CONSUMABLE)); // userSlice store
                setOpen(false);
                setDisplayFilter(false);
            } else if (res?.payload?.errorcode === 1012) {
                setError(t("msg_master_list.msg_consumable.duplicate_consumable"));
                setIsError(true);
            } else {
                setError(t("msg_master_list.msg_consumable.consumable_add_error"));
                setIsError(true);
            }
        });
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleRowSelected = ({ selectedRows }) => {
        const selectConsumable = selectedRows.map((item) => item._id);
        setSelectedItem([...selectConsumable]);
    };


    const confirmBeforeDelete = (data, singleDelete = false) => {
        if (singleDelete) {
            setSelectedItem([data._id]);
            setConfirmModel(true);
        } else {
            if (selectedItem.length === 0) {
                setIsAlert(true);
                return
            } else {
                setConfirmModel(true);
            }
        }
    };

    const resetAlert = () => {
        setIsAlert(false);
    };

    const resetError = () => {
        setIsError(false);
        setError("");
    };

    const handleOpen = (data) => {
        if (data) {
            setEditConsumableSize(data);
        }
        setOpen(true);
    };

    const handleUploadOpen = (data) => {
        setUploadModelOpen(true);
    };

    const columnsData = [
        {
            name: t("msg_common.actions"),
            cell: (row) => (
                <>
                    <span>
                        <i
                            className="bi bi-pencil-square iconTable"
                            onClick={() => handleOpen(row)}
                        ></i>
                    </span>
                    <span>
                        <i
                            className="bi bi-trash3 iconTable"
                            onClick={() => confirmBeforeDelete(row, true)}
                        ></i>
                    </span>
                </>
            ),
            width: "100px",
        },
        {
            name: t("msg_master_list.msg_department.code"),
            selector: (row) => row.deptCode,
            sortable: true,
            width: "200px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptCode} </p>
                </div>
            ),
        },
        {
            name: t("msg_master_list.msg_department.name"),
            selector: (row) => row.deptName,
            sortable: true,
            width: "200px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptName} </p>
                </div>
            ),
        },
        {
            name: t("msg_master_list.msg_size.code"),
            selector: (row) => row.sizeCode,
            sortable: true,
            width: "200px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.sizeCode} </p>
                </div>
            ),
        },
        {
            name: t("msg_master_list.msg_size.name"),
            selector: (row) => row.sizeName,
            sortable: true,
            width: "200px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.sizeName} </p>
                </div>
            ),
        },
        {
            name: t("msg_master_list.msg_consumable.consumptionCode"),
            selector: (row) => row.consumptionCode,
            sortable: true,
            width: "200px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.consumptionCode} </p>
                </div>
            ),
        },
        {
            name: t("msg_master_list.msg_consumable.ConsumptionType"),
            selector: (row) => row.consumptionType,
            sortable: true,
            width: "200px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.consumptionType} </p>
                </div>
            ),
        },
        {
            name: t("msg_master_list.msg_consumable.ConsumableSize"),
            selector: (row) => row.consumableSize,
            sortable: true,
            width: "200px",
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{row.consumableSize} </p>
                </div>
            ),
        },
        {
            name: t("msg_common.created_date"),
            selector: (row) => row.createdDate,
            sortable: true,
            cell: (row) => (
                <div>
                    <p className="m-0 p-0 pt-1 fw-datatable-row">{formatDateTime(row?.createdDate)} </p>
                </div>
            ),
            center: true,
            width: "200px",
        },
    ];

    const handleUploadData = async (data) => {
        try {
            let consumableRecords = [];
            if (data) {
                // eslint-disable-next-line array-callback-return
                data.map((item, index) => {

                    if (!item?.DepartmentCode || !item?.DepartmentName) {
                        setError(t("msg_master_list.msg_consumable.dept_info_missing"));
                        setIsError(true);
                        throw new Error(t("msg_master_list.msg_consumable.dept_info_missing"));
                    }

                    if (!item?.SizeCode || !item?.SizeName) {
                        setError(t("msg_master_list.msg_consumable.size_info_missing"));
                        setIsError(true);
                        throw new Error(t("msg_master_list.msg_consumable.size_info_missing"));
                    }

                    if (!item?.ConsumptionCode || !item?.ConsumptionType) {
                        setError(t("msg_master_list.msg_consumable.consumption_info_missing"));
                        setIsError(true);
                        throw new Error(t("msg_master_list.msg_consumable.consumption_info_missing"));
                    }

                    if (!item?.ConsumableSize) {
                        setError(t("msg_master_list.msg_consumable.consumablesize_info_missing"));
                        setIsError(true);
                        throw new Error(t("msg_master_list.msg_consumable.consumablesize_info_missing"));
                    }

                    consumableRecords.push(item);
                });
            }
            let consumableParam = {};
            consumableParam.consumableRecords = consumableRecords;

            consumableParam.method = Constants.MASTER.CONSUMABLE.UPLOAD;

            const res = await dispatch(addMasterRecord(consumableParam))
            if (res?.payload?.status === 200) {
                toastFunc(
                    Constants.MASTER.TOAST.success,
                    t("msg_master_list.msg_consumable.success_message"),
                    2000
                );
                dispatch(fetchMasterList(Constants.MASTER.CONSUMABLE));
                setUploadModelOpen(false);
            } else {
                setError(res.payload.message);
                setIsError(true);
                setUploadModelOpen(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const searchOperation = async (searchObj) => {


        let param = {};
        param.page = 1;

        param.filter = {
            sizeCode: searchObj.sizeCode,
            jobcard: searchObj.jobcard,
            deptCode: searchObj.deptCode,
            machineCode: searchObj.machineCode,
            consumptionType: searchObj.consumptionType,
            consumptionCode: searchObj.consumptionCode
        };
        param.download = searchObj.download;

        param.name = Constants.MASTER.CONSUMABLE.name;
        param.method = Constants.MASTER.CONSUMABLE.SEARCH;

        dispatch(fetchReportsList(param)).then((res) => {
            if(!searchObj.download) {
                setRowsData(res?.payload?.items);
            }
        });
    };


    return (
        <main className="dashboard main" id="main">
            <Row className="justify-center subContent">
                <Col xs={8} md={8} className="rightSide">
                    <div className="rightSideInner timesheet">
                        <h2 className="mainTitle">
                            {t("msg_master_list.msg_consumable.name")}
                        </h2>
                        <p className="subText">{t("msg_master_list.msg_consumable.details")}</p>
                    </div>
                </Col>
                <Col xs={4} md={4} className="leftSide">
                    <Button
                        type="button"
                        variant="primary"
                        size="lg"
                        className="btn btn-primary float-right searchFilter-btn"
                        onClick={() => setDisplayFilter(!displayFilter)}
                    >
                        <i className="bi bi-filter"> </i>
                    </Button>
                </Col>
                <hr />
            </Row>
            {
                displayFilter &&
                (
                    <Row className="reportheader">
                        <Col xs={12} md={12} className="rightSide">
                            <ProdStatusFilterBox
                                searchData={searchOperation}
                                deptOptionReq={true}
                                //jobcardStatusReq={props.jobcardStatusReq === false ? false : true}
                                // customer={props.customer === false ? false : true}
                                //  required_date={props.required_date === false ? false : true}
                                // plan={props.plan === false ? false : true}
                                //  planType={props.planType === false ? false : true}
                                // CompletedDate={props.CompletedDate === false ? false : true}
                                handleDownload={searchOperation}
                                resetFilerBox={() => setDisplayFilter(false)}
                                resetSearch={() => setDisplayFilter(false)}
                                //   downloadProgress={downloadProgress}
                                pageName={Constants.MASTER.CONSUMABLE.name}
                            ></ProdStatusFilterBox>
                        </Col>
                    </Row>
                )
            }

            <MasterList
                columnsData={columnsData}
                rowsData={rowsData}
                paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                pagination
                selectableRows
                handleClose
                uploadButton
                handleOpen={handleOpen}
                uploadData={handleUploadOpen}
                handleDelete={confirmBeforeDelete}
                handleRowSelected={handleRowSelected}
            />
            {uploadModelOpen && (
                <UploadExcel
                    show={uploadModelOpen}
                    onHide={handleUploadClose}
                    handleFileUploadData={handleUploadData}
                ></UploadExcel>
            )}
            {open && (
                <ConsumableModal
                    data={editConsumableSize}
                    show={open}
                    onHide={handleClose}
                    onSave={handleSave}
                ></ConsumableModal>
            )}
            {confirmModel && (
                <ConfirmationModal
                    show={confirmModel}
                    heading={t("msg_master_list.msg_consumable.delete_confirm_heading")}
                    bodyMessage={t("msg_master_list.msg_consumable.delete_confirm_body")}
                    onDelete={() => handleDelete()}
                    onHide={() => setConfirmModel(false)}
                    type={"delete"}
                ></ConfirmationModal>
            )}
            {isError && (
                <ErrorModal
                    show={isError}
                    heading={t("msg_master_list.msg_consumable.consumable_error_heading")}
                    bodyMessage={error}
                    onHide={() => {
                        resetError();
                    }}
                ></ErrorModal>
            )}
            {isAlert && (
                <AlertModal
                    show={isAlert}
                    heading={t("msg_common.alert")}
                    bodyMessage={t("msg_common.selectRecord")}
                    onHide={() => {
                        resetAlert();
                    }}
                ></AlertModal>
            )}
        </main>
    );
};

export default Consumable;

